module.exports = new __parcel__URL__("printIcon.02e99050.svg").toString();